// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdrawMain {
  background-color: #07405e;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
}
.withdrawMain .withdrawContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .withdrawMain .withdrawContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .withdrawMain .withdrawContainer {
    height: 100%;
  }
}
.withdrawMain .withdrawContainer .balanceBlock {
  display: flex;
  flex-direction: column;
  margin: 20px 0px;
  width: 97%;
}
.withdrawMain .withdrawContainer .balanceBlock h2 {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
}
.withdrawMain .withdrawContainer .balanceBlock p {
  color: #FFFFFF;
  font-family: "Bitter", serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  padding: 0;
}
.withdrawMain .withdrawContainer .balanceBlock .dollarSign {
  color: #699BB6;
  font-family: "Bitter", serif;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.withdrawMain .withdrawContainer input::-webkit-outer-spin-button,
.withdrawMain .withdrawContainer input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.withdrawMain .withdrawContainer input[type=number] {
  -moz-appearance: textfield;
}
.withdrawMain .withdrawContainer .generalLabel {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  margin-left: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  width: 100%;
}
.withdrawMain .withdrawContainer .inputContainer, .withdrawMain .withdrawContainer .withdrawInputContainer {
  background-color: rgba(105, 155, 182, 0.4);
  padding: 10px;
  width: 97%;
  position: relative;
}
.withdrawMain .withdrawContainer .inputContainer:first-child, .withdrawMain .withdrawContainer .withdrawInputContainer {
  border-radius: 10px;
}
.withdrawMain .withdrawContainer .inputContainer:last-child {
  border-radius: 10px;
}
.withdrawMain .withdrawContainer label {
  color: #699BB6;
  font-family: Arial;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
.withdrawMain .withdrawContainer .withdrawInput {
  width: 100%;
  padding: 10px;
  border: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  -webkit-border-bottom-left-radius: 0px;
  -webkit-border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border: none;
  font-family: Arial;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #FFFFFF;
  background: transparent;
  padding: 0;
  margin: 0;
}
.withdrawMain .withdrawContainer .withdrawInputBlock {
  display: flex;
  align-items: center;
  border-radius: 5px;
}
.withdrawMain .withdrawContainer .withdrawInputBlock .currencyWithdraw {
  color: #699BB6;
  font-family: Arial;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-right: 10px;
}
.withdrawMain .withdrawContainer .withdrawInputBlock .maxWithdraw {
  height: 25px;
  border-radius: 8px;
  padding: 2px 10px;
  border: 0.8px solid #699BB6;
  background: rgba(255, 255, 255, 0);
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  cursor: pointer;
  font-style: normal;
  font-weight: 700;
}
.withdrawMain .withdrawContainer input:focus {
  outline: none;
}
.withdrawMain .withdrawContainer .minimumAmount {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  position: inherit;
  width: 100%;
  left: 0;
  bottom: -40px;
  margin-left: 10px;
}
.withdrawMain .withdrawContainer .cryptoWalletBlock {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.withdrawMain .withdrawContainer .cryptoWalletBlock .inputContainer:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom: 1px solid #699BB6;
}
.withdrawMain .withdrawContainer .cryptoWalletBlock .inputContainer:first-child input {
  color: #699BB6;
}
.withdrawMain .withdrawContainer .cryptoWalletBlock .inputContainer:nth-child(2) {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.withdrawMain .withdrawContainer .agreementBlock {
  display: flex;
  margin-top: 20px;
  align-items: flex-start;
  width: 97%;
  gap: 10px;
  position: relative;
  border-radius: 10px;
}
.withdrawMain .withdrawContainer .agreementBlock .agreementBtn {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-top: 20px;
  background-color: #216B93;
  border: 2px solid #699BB6;
}
.withdrawMain .withdrawContainer .agreementBlock .selectedAgreement {
  background-color: #FFFFFF;
  border: 7px solid #FF6B6B;
  position: relative;
}
.withdrawMain .withdrawContainer .agreementBlock .selectedAgreement::after {
  content: "";
  height: 28px;
  width: 28px;
  border-radius: 20px;
  top: -8.5px;
  left: -8.5px;
  z-index: -1;
  position: absolute;
  background-color: #FFFFFF;
}
.withdrawMain .withdrawContainer .agreementBlock .agreementTextBlock {
  width: 90%;
}
.withdrawMain .withdrawContainer .agreementBlock .agreementTextBlock .agreementText {
  color: #699BB6;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
.withdrawMain .withdrawContainer .agreementBlock .agreementTextBlock .agreementText:first-child {
  margin-bottom: 0;
}
.withdrawMain .withdrawContainer .agreementBlock .agreementTextBlock .agreementText:last-child {
  margin: 0;
}
.withdrawMain .withdrawContainer .withdrawButton {
  margin-top: 30px;
  width: 320px;
  padding: 15px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  border: 0px solid;
  position: absolute;
  bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/modules/withdraw/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AADF;AAEE;EAIE,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AANJ;AANI;EADF;IAEI,YAAA;EASJ;AACF;AAPI;EALF;IAMI,YAAA;EAUJ;AACF;AAHI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;AAKR;AAJQ;EACI,cC9BK;ED+BL,iCE3BH;EF4BG,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AAMZ;AAHQ;EACI,cC1CC;ED2CD,4BE1CH;EF2CG,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAKZ;AAHQ;EACI,cCnDK;EDoDL,4BEpDH;EFqDG,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKZ;AAFI;;EAEI,wBAAA;EACA,SAAA;AAIR;AADI;EACI,0BAAA;AAGR;AADI;EACE,cCrEW;EDsEX,iCElEG;EFmEH,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AAGN;AAAI;EACE,0CAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AAEN;AAAI;EACE,mBAAA;AAEN;AACI;EACI,mBAAA;AACR;AAEM;EACA,cC/FW;EDgGX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAN;AAGI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,uCAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCxHO;EDyHP,uBAAA;EACA,UAAA;EACA,SAAA;AADN;AAII;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAGQ;EACI,cClIK;EDmIL,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADZ;AAGQ;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kCAAA;EACA,cChJK;EDiJL,iCE7IH;EF8IG,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AADZ;AAKI;EACE,aAAA;AAHN;AAMG;EACG,cC9JW;ED+JX,iCE3JG;EF4JH,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,iBAAA;AAJN;AAOI;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AALR;AAOQ;EACI,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;AALZ;AAMY;EACI,cCxLC;ADoLjB;AAQU;EACE,+BAAA;EACA,gCAAA;EACA,2BAAA;EACA,4BAAA;AANZ;AASQ;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAPZ;AAQY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBCxMI;EDyMJ,yBAAA;AANhB;AASY;EACI,yBCtNH;EDuNG,yBAAA;EACA,kBAAA;AAPhB;AASY;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAPhB;AASY;EACI,UAAA;AAPhB;AAQgB;EACI,cCvOH;EDwOG,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANpB;AAQgB;EACI,gBAAA;AANpB;AAQgB;EACI,SAAA;AANpB;AAYI;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,cC/PK;EDgQL,iCE3PC;EF4PD,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAVR","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.withdrawMain {\n  background-color: #07405e;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100dvh;\n  position: fixed;\n  .withdrawContainer {\n    @media (min-width: 450px) {\n      width: 400px;\n    }\n    height: 85%;\n    @media only screen and (max-height: 712px) {\n      height: 100%;\n    }\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    padding: 10px;\n    .balanceBlock{\n        display: flex;\n        flex-direction: column;\n        margin: 20px 0px;\n        width: 97%;\n        h2{\n            color: $color-Secondary;\n            font-family: $Roboto;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            text-transform: uppercase;\n            margin: 0;\n            padding: 0;\n\n        }\n        p{\n            color: $color-White;\n            font-family: $Bitter;\n            font-size: 36px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n            margin: 0;\n            padding: 0;\n        }\n        .dollarSign{\n            color: $color-Secondary;\n            font-family: $Bitter;\n            font-size: 21px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal\n        }\n    }\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0; \n    }\n\n    input[type=number] {\n        -moz-appearance:textfield;\n    }\n    .generalLabel {\n      color: $color-Secondary;\n      font-family: $Roboto;\n      font-size: 14px;\n      margin-left: 40px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      text-transform: uppercase;\n      width: 100%;\n    }\n\n    .inputContainer, .withdrawInputContainer {\n      background-color: rgba(105, 155, 182, 0.4);\n      padding: 10px;\n      width: 97%;\n      position: relative;\n    }\n    .inputContainer:first-child , .withdrawInputContainer{\n      border-radius: 10px;\n    }\n  \n    .inputContainer:last-child {\n        border-radius: 10px;\n    }\n\n      label {\n      color: $color-Secondary;\n      font-family: Arial;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n    }\n  \n    .withdrawInput {\n      width: 100%;\n      padding: 10px;\n      border: none;\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n      -webkit-border-bottom-left-radius: 0px;\n      -webkit-border-bottom-right-radius: 0px;\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n      border: none;\n      font-family: Arial;\n      font-size: 17px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n      color: $color-White;\n      background: transparent;\n      padding: 0;\n      margin: 0;\n    }\n    \n    .withdrawInputBlock{\n        display: flex;\n        align-items: center;\n        border-radius: 5px;\n        .currencyWithdraw{\n            color: $color-Secondary;\n            font-family: Arial;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 140%;\n            margin-right: 10px;   \n        }\n        .maxWithdraw{\n            height: 25px;\n            border-radius: 8px;\n            padding: 2px 10px;\n            border: 0.8px solid $color-Secondary;\n            background: rgba(255, 255, 255, 0);\n            color: $color-Secondary;\n            font-family: $Roboto;\n            font-size: 16px;\n            cursor: pointer;\n            font-style: normal;\n            font-weight: 700;\n        }\n    }\n\n    input:focus {\n      outline: none;\n    }\n\n   .minimumAmount{\n      color: $color-Secondary;\n      font-family: $Roboto;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      position: inherit;\n      width: 100%;\n      left: 0;\n      bottom: -40px;\n      margin-left: 10px;     \n    }\n\n    .cryptoWalletBlock{\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    \n        .inputContainer:first-child {\n            border-top-left-radius: 10px;\n            border-top-right-radius: 10px;\n            border-bottom-left-radius: 0px;\n            border-bottom-right-radius: 0px;\n            border-bottom: 1px solid $color-Secondary;\n            input{\n                color: $color-Secondary;\n            }\n          }\n        \n          .inputContainer:nth-child(2) {\n            border-bottom-left-radius: 10px;\n            border-bottom-right-radius: 10px;\n            border-top-left-radius: 0px;\n            border-top-right-radius: 0px;\n          }\n    }\n        .agreementBlock{\n            display: flex;\n            margin-top: 20px;\n            align-items: flex-start;\n            width: 97%;\n            gap: 10px;\n            position: relative;\n            border-radius: 10px;\n            .agreementBtn{\n                width: 25px;\n                height: 25px;\n                border-radius: 15px;\n                margin-top: 20px;\n                background-color: $color-Gradient-1-1;\n                border: 2px solid $color-Secondary;\n                \n            }\n            .selectedAgreement{\n                background-color: $color-White;\n                border: 7px solid $color-Gradient-2-2;\n                position: relative;\n            }\n            .selectedAgreement::after{\n                content: \"\";\n                height: 28px;\n                width: 28px;\n                border-radius: 20px;\n                top: -8.5px;\n                left: -8.5px;\n                z-index: -1;\n                position: absolute;\n                background-color: #FFFFFF;\n            }\n            .agreementTextBlock{\n                width: 90%;\n                .agreementText{\n                    color: $color-Secondary;\n                    font-family: Arial;\n                    font-size: 14px;\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 140%;   \n                }\n                .agreementText:first-child{\n                    margin-bottom: 0; \n                }\n                .agreementText:last-child{\n                    margin: 0; \n                }\n            }\n            \n        }\n \n    .withdrawButton  {\n        margin-top: 30px;\n        width: 320px;\n        padding: 15px;\n        background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n        text-align: center;\n        color: $color-White;\n        font-family: $Roboto;\n        font-weight: 400;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10px;\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        border:0px solid;\n        position: absolute;\n        bottom: 20px;\n    }\n    }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
